<template>
	<div class="matters_list">
    <el-form ref="baseForm" :rules="rules" :model="fromData">
    <search-box @subSearch="subSearch" :fromData="fromData">
      <el-form-item class="item" label="物料：" prop="codeOrDesc">
        <el-input  v-model="fromData.searchCriteria.codeOrDesc" :placeholder="$store.state.remark.matter"></el-input>
      </el-form-item>
      <!-- <el-form-item class="item" label="物料描述：" prop="materialDesc">
        <el-input  v-model="fromData.searchCriteria.materialDesc" :placeholder="$store.state.remark.matterDesc"></el-input>
      </el-form-item> -->
    </search-box>
    </el-form>

    <tab-list
    setHeadBtn
    tabCheckbox
    ref="multipleTable"
    tabHeight="310" 
    :selectedList="selectedList"
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="matters-orderNew-list"
    @getSelect="getSelect"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata">
    </tab-list> 
	</div>
</template>
<script>
import {salepricelist} from 'api/stock.js';
import tabList from 'components/table/list.vue';
import searchBox from 'components/common/search.vue';
export default{
  components:{
    tabList,searchBox
  },
  props:{
  	//已选列表,未添加到数据库
    selectedList:Array,
    fromData: Object,
  },
	data(){
		return{
			sdata:{},
			listArr:[],//列表
      rules: {
        codeOrDesc:[{message: "",trigger: "blur"}],
      },
			tabColumns:[
        {field: 'materialId', title: '物料号', width:90,"sortable":true},
			  {field: 'materialCode', title: '物料编码'},
        {field: 'materialDesc', title: '物料描述', width:90},
        {field: 'materialGroupDesc', title: '物料组',
        formatter(row, column, cellValue, index){
				  let desc = row.materialGroupDesc;
				  let code = row.materialGroup;
				  return code +'-'+desc;
				}},
			  {field: 'specifications', title: '规格', width:60},
			  {field: 'basicUnitDesc', title: '基本单位', width:60},
				{field: 'availableStock', title: '库存数量', width: 80},
				{field: 'factoryCode', title: '工厂',
				formatter(row, column, cellValue, index){
				  let desc = row.factoryDesc;
				  let code = row.factoryCode;
				  return code +'-'+desc;
				}},
				{field: 'factoryDesc', title: '库存地点',
				formatter(row, column, cellValue, index){
				  let desc = row.inventoryDesc ? row.inventoryDesc : '';
				  let code = row.inventoryCode ? row.inventoryCode : '';
				  return code + '-'+desc;
				}}
			],//表头字段
			isDelList:false,//是否显示已删除的
			total:0,//总条数
			pages:0,//总页数
		}
	},
	watch:{
		//监听选择的变化
    selectedList:{
      handler:function(newVal){
        if(this.selectedList.length != newVal.length){
          this.getList();
        }
      },
      deep:true
    },
    fromData:{
      handler:function(){
        console.log(11,'条件改变');
        this.getList();
      },
      deep:true
    }
	}, 
	created(){
		this.getList();
	},
	methods:{
    //取消选择
    cancelSelect(){
      this.$refs.multipleTable.cancelSelect();
    },
    //获取已选
    getSelect(res){
      this.$emit('getSelect',res);
    },
    //选中数据
    selectSdata(data){
      this.sdata = data;
    },
		//初始化需要获取的数据
		async getList(){
      this.fromData.searchCriteria.companyId = this.fromData.companyId
      console.log(this.fromData,9999);
      let res = await this.$post(salepricelist.list,this.fromData);
      console.log(res)
      const { data,msg,msgCode,status,type,code} = res;
      if(!status) return false;
      if(data.list){
        data.list.map((item)=>{
          return item.selectId = '' + item.materialCode + item.factoryCode + item.inventoryCode;
        });
        this.listArr = data.list;
        this.pages = data.pages;
        this.total = data.total;
      }
		},
		//当前页码改变
		currentChange(currentPage){
			this.fromData.page = currentPage;
			this.getList();
		},
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
		//搜索按钮
		subSearch(){
			this.fromData.page = 1;
			this.getList();
		},
		handleSelectChange(item,key){
			if(item.isLock) return false;
			if(item.isChecked){
				item.isChecked = false;
				this.selectList.splice(key,1);
			}else{
				item.isChecked = true;
				this.selectList.push(item);
			}
		}
	}
}
</script>

<style>
</style>
